import { LitElement, html } from '@hh/global.js'

class ProductCard extends LitElement {
  static properties = {}

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.handleLinkClick()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  handleLinkClick() {
    this.addEventListener('click', (e) => {
      const clickedLink = e.target.closest('[data-product-card-link]')
      if (!clickedLink || !this.contains(clickedLink)) return

      const linkHasPageReference = clickedLink.closest('[data-page]')
      if (!linkHasPageReference) return

      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return

      e.preventDefault()

      const updatedURL = new URL(window.location.href)

      if (linkHasPageReference.hasAttribute('id')) {
        updatedURL.hash = linkHasPageReference.getAttribute('id')
      }

      updatedURL.searchParams.set('page', linkHasPageReference.dataset.page)

      history.pushState({}, '', updatedURL.toString())

      window.location.href = clickedLink.getAttribute('href')
    })
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-product-card', ProductCard)
